export interface Printer {
  brand: 'Brother';
  model: 'QL-820NWB' | 'QL-820NWBc';
  type: 'bluetooth';
  serialNumber: string;
}

export enum PrinterSearchErrorCode {
  PrinterSearchErrorNoError = 30100,
  PrinterSearchErrorCanceled,
  PrinterSearchErrorAlreadySearching,
  PrinterSearchErrorUnsupported,
  PrinterSearchErrorUnknownError,
}

export enum PrinterOpenChannelErrorCode {
  OpenChannelErrorCodeNoError = 30000,
  OpenChannelErrorCodeOpenStreamFailure,
  OpenChannelErrorCodeTimeout,
}

export enum PrinterPrintErrorCode {
  PrintErrorCodeNoError = 0,
  PrintErrorCodePrintSettingsError,
  PrintErrorCodeFilepathURLError,
  PrintErrorCodePDFPageError,
  PrintErrorCodePrintSettingsNotSupportError,
  PrintErrorCodeDataBufferError,
  PrintErrorCodePrinterModelError,
  PrintErrorCodeCanceled,
  PrintErrorCodeChannelTimeout,
  PrintErrorCodeSetModelError,
  PrintErrorCodeUnsupportedFile,
  PrintErrorCodeSetMarginError,
  PrintErrorCodeSetLabelSizeError,
  PrintErrorCodeCustomPaperSizeError,
  PrintErrorCodeSetLengthError,
  PrintErrorCodeTubeSettingError,
  PrintErrorCodeChannelErrorStreamStatusError,
  PrintErrorCodeChannelErrorUnsupportedChannel,
  PrintErrorCodePrinterStatusErrorPaperEmpty,
  PrintErrorCodePrinterStatusErrorCoverOpen,
  PrintErrorCodePrinterStatusErrorBusy,
  PrintErrorCodePrinterStatusErrorPrinterTurnedOff,
  PrintErrorCodePrinterStatusErrorBatteryWeak,
  PrintErrorCodePrinterStatusErrorExpansionBufferFull,
  PrintErrorCodePrinterStatusErrorCommunicationError,
  PrintErrorCodePrinterStatusErrorPaperJam,
  PrintErrorCodePrinterStatusErrorMediaCannotBeFed,
  PrintErrorCodePrinterStatusErrorOverHeat,
  PrintErrorCodePrinterStatusErrorHighVoltageAdapter,
  PrintErrorCodeUnsupportedCharger,
  PrintErrorCodeIncompatibleOptionalEquipment,
  PrintErrorCodePrinterStatusErrorUnknownError,
  PrintErrorCodeTemplatePrintNotSupported,
  PrintErrorCodeInvalidTemplateKey,
  PrintErrorCodeUnknownError,
}

export enum CustomPrintingErrorCode {
  // 42000 is the first custom error code that comes from the Capacitor plugin
  MissingParameters = 42000,
  DownloadBadgeFailed,
  InvalidPrinter,
  FailedToConnectToPrinter,
  FailedToGetPrintSettings,
  // 42100 is the first custom error code that comes from the frontend code
  CheckInFailed = 42100,
  UnableToGenerateBadge,
}

export enum PrinterErrorCategory {
  UnableToConnectToPrinter,
  UnableToGenerateBadge,
  PrinterNetwork,
  PrinterCoverOpen,
  PrinterOffline,
  PrinterLowBattery,
  PrinterOverheated,
  PrinterPower,
  PrinterConfiguration,
  PageConfiguration,
  PaperError,
  UnknownError,
  PrintCancelled,
  SearchError,
  BusyError,
  CheckInFailed,
}

export type PrinterErrorCodes =
  | PrinterSearchErrorCode
  | PrinterOpenChannelErrorCode
  | PrinterPrintErrorCode
  | CustomPrintingErrorCode;

export interface PrintJobOptions {
  /** Defaults to 1 */
  numCopies?: number;
  /** The printer that should be used */
  printer?: Printer;
}

export interface CapacitorPrintOptions extends PrintJobOptions {
  badgeUrl: string;
}

export interface BadgePrinterPlugin {
  findBluetoothPrinters(): Promise<{ printers: Printer[] }>;
  printBadge(options: CapacitorPrintOptions): Promise<{ result: boolean }>;
  openNativeBluetoothSettings(): Promise<void>;
}
